import { Component, Inject, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { EmpresasService } from "@p-parametria/mantenimiento/abc-empresas/services/empresas.service";
import { SwalService } from "@shared/utils/swal.service";
import {
    IGetCampoNuevoReq,
    IGetCampoNuevoRes,
    IGetCamposReq,
    IGetCamposRes,
    IGetTablasCampoReq,
} from "@p-parametria/mantenimiento/abc-empresas/interfaces/ICustomizables";
import moment = require("moment");
import { HelpersService } from "@shared/helpers/helpers.service";
import Swal from "sweetalert2";

export interface ICustomizablesData {
    sTabla: string;
    sClave: string;
    sNombre: string;
    sTipo: string;
}

interface ITablasCampoResponse {
    success: boolean;
    data: Array<{
        sEtiqueta?: string;
        sValor?: string;
    }>;
}

@Component({
    selector: "app-abc-empresas-customizables",
    templateUrl: "./abc-empresas-customizables.component.html",
    styleUrls: ["./abc-empresas-customizables.component.css"],
})
export class AbcEmpresasCustomizablesComponent implements OnInit {
    dataSource: any;
    newModal: boolean = false;
    newModalValue: boolean = false;
    loading: boolean = false;

    listCustomizables: any = [];
    listOpciones: string[] = [];
    valueNewCustomizable: string = "";

    valueCustom: any;
    customItem: any;
    valueLong: number = 0;
    maxValue: number = 0;

    readonly TIPO_CAMPO = {
        ALFANUMERICO: 'Alfanum',
        NUMERICO: 'Numerico',
        FECHA: 'Fecha',
        OPCION: 'Opcion'
    };

    columns = [
        { field: 'sCampo', header: 'Descripción' },
        { field: 'sValor', header: 'Valor' },
        { field: 'actions', header: 'Acciones' }
    ];

    constructor(
        private _fb: UntypedFormBuilder,
        private _dialogRef: MatDialogRef<AbcEmpresasCustomizablesComponent>,
        private _helpers: HelpersService,
        private empresasService: EmpresasService,
        private _swalService: SwalService,
        public _dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public model: any
    ) {}

    ngOnInit(): void {
        this.getCampos();
        this.getCustomizablesOptions();
    }

    getCampos() {
        this.loading = true;
        const payload: IGetCamposReq = {
            tope: "999",
            cmd: "",
            sCampo: "",
            sTabla: this.model.sTabla || "empresas",
            sClave: this.model.sClave || this.model.sEmpresa,
            sValor: "",
        };
        this.empresasService.GetCampos(payload).subscribe({
            next: (res: IGetCamposRes) => {
                this.dataSource = res.data;
                this.loading = false;   
            },
            error: (err) => {
                console.error('Error al cargar campos:', err);
                this._swalService.error('Error al cargar los campos customizables');
                this.loading = false;
            }
        });
    }

    getCustomizablesOptions() {
        this.loading = true;
        const payload: IGetCampoNuevoReq = {
            tope: "999",
            cmd: "",
            sCampo: "",
            sTabla: this.model.sTabla || "empresas",
            sTipo: "",
            iLongitud: 0,
        };
        this.empresasService.GetCampoNuevo(payload).subscribe({
            next: (res: IGetCampoNuevoRes) => {
                this.listCustomizables = res.data;
                this.loading = false;
            },
            error: (err) => {
                console.error('Error al cargar opciones:', err);
                this._swalService.error('Error al cargar la lista de customizables');
                this.loading = false;
            }
        });
    }

    addCustomizable() {
        if (!this.valueNewCustomizable) return;

        this.loading = true;
        const payload: IGetCamposReq = {
            tope: "1",
            cmd: "",
            sCampo: this.valueNewCustomizable,
            sTabla: this.model.sTabla || "empresas",
            sClave: this.model.sClave || this.model.sEmpresa,
            sValor: "",
        };
        this.empresasService.EditCampos(payload).subscribe({
            next: (res) => {
                if (res.data.result === 0) {
                    this._swalService.success('Customizable agregado correctamente');
                    this.valueNewCustomizable = "";
                    this.newModal = false;
                    this.getCampos();
                } else {
                    this._swalService.error('Error al agregar el customizable');
                }
                this.loading = false;
            },
            error: (err) => {
                console.error('Error al agregar customizable:', err);
                this._swalService.error('Error al agregar el customizable');
                this.loading = false;
            },
        });
    }

    editValueCustom(model: any) {
        console.log("Modelo Para editar:", model);
        this.customItem = model;
        this.newModalValue = true;
        if (model.sTipo === this.TIPO_CAMPO.FECHA) {
            this.valueCustom = moment(model.sValor, "D/M/YYYY").format("YYYY-MM-DD");
        } else {
            this.valueCustom = model.sValor;
        }
        this.getLongitud(model.sCampo);
        
        // Si es tipo opción, cargar las opciones
        if (model.sTipo === this.TIPO_CAMPO.OPCION) {
            this.loadOpciones(model.sCampo);
        }
    }

    loadOpciones(descripcion: string): void {
        console.log('Cargando opciones para:', descripcion);
        
        const payload = {
            tope: "100",
            sCampo: descripcion,
            sTabla: this.model.sTabla || "empresas"
        };

        this.empresasService.GetOpcionesEmpresa(payload).subscribe({
            next: (response) => {
                if (response.data) {
                    this.listOpciones = response.data.map(item => item.sOpcion);
                } else {
                    console.error('Formato de respuesta inválido:', response);
                    this.listOpciones = [];
                }
            },
            error: (error) => {
                console.error('Error al cargar opciones:', error);
                this.listOpciones = [];
            }
        });
    }

    sendValueCustom() {
        if (!this.valueCustom) return;

        this.loading = true;
        console.log("Valor a enviar", this.customItem, this.valueCustom);
        
        // Asegurarse de que el valor sea string
        let valorAEnviar = '';
        
        if (this.customItem.sTipo === this.TIPO_CAMPO.FECHA) {
            valorAEnviar = this._helpers.convertDateToDDMMYYYString(this.valueCustom);
        } else if (this.customItem.sTipo === this.TIPO_CAMPO.NUMERICO) {
            valorAEnviar = this.valueCustom?.toString() || '';
        } else {
            valorAEnviar = this.valueCustom || '';
        }

        const payload: IGetCamposReq = {
            tope: "1",
            cmd: "",
            sCampo: this.customItem.sCampo,
            sTabla: this.model.sTabla || "empresas",
            sClave: this.model.sEmpresa || this.model.sClave,
            sValor: valorAEnviar,
        };

        console.log('Payload a enviar:', payload);

        this.empresasService.EditCampos(payload).subscribe({
            next: (res) => {
                if (res.data.result === 0) {
                    this._swalService.success('Customizable actualizado correctamente');
                    this.newModalValue = false;
                    this.getCampos();
                } else {
                    this._swalService.error('Error al actualizar el customizable');
                }
                this.loading = false;
            },
            error: (err) => {
                console.error('Error al actualizar customizable:', err);
                this._swalService.error('Error al actualizar el customizable');
                this.loading = false;
            },
        });
    }

    deleteCustom(model: any) {
        Swal.fire({
            title: `Eliminar customizable`,
            showCancelButton: true,
            text: `¿Está seguro de eliminar el campo «${model.sCampo}»?`,
            icon: "warning",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "No",
            iconColor: "#d33",
            confirmButtonColor: "#d33",
            heightAuto: false,
            customClass: {
                container: "swal-index",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                this.loading = true;
                const payload: IGetCamposReq = {
                    tope: "3",
                    cmd: "",
                    sCampo: model.sCampo,
                    sTabla: model.sTabla,
                    sClave: model.sClave,
                    sValor: "",
                };
                this.empresasService.DeleteCampos(payload).subscribe({
                    next: (res) => {
                        if (res.data.error === 0) {
                            this._swalService.success('Customizable eliminado correctamente');
                            this.getCampos();
                        } else {
                            this._swalService.error('Error al eliminar el customizable');
                        }
                        this.loading = false;
                    },
                    error: (err) => {
                        console.error('Error al eliminar customizable:', err);
                        this._swalService.error('Error al eliminar el customizable');
                        this.loading = false;
                    },
                });
            }
        });
    }

    getInputType(type: string) {
        switch (type) {
            case this.TIPO_CAMPO.NUMERICO:
                return "number";
            case this.TIPO_CAMPO.ALFANUMERICO:
                return "text";
            case this.TIPO_CAMPO.FECHA:
                return "date";
            case this.TIPO_CAMPO.OPCION:
                return "select";
            default:
                return "text";
        }
    }

    getLongitud(sCampo: string): void {
        if (sCampo === "") {
            return;
        }
        const campo = this.listCustomizables.find((x: any) => x.sCampo === sCampo);
        if (campo) {
            this.valueLong = campo.iLongitud;
            this.getMaxValue(this.valueLong);
        }
    }

    getMaxValue(length: number): void {
        this.maxValue = Number("9".repeat(length)); // Si length = 4, retorna 9999
    }

    enforceMaxLength(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.value.length > this.valueLong) {
            input.value = input.value.slice(0, this.valueLong);
            this.valueCustom = input.value;
        }
    }

    close() {
        this._dialogRef.close();
    }

    onNewModalShow(): void {
        // Limpiar el valor del dropdown cuando se abre el dialog
        this.valueNewCustomizable = "";
    }
}
